var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 33.25V26.25H28L21 17.5L14 26.25H19.25V33.25H22.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 33.25H15.75V29.75H12.25C9.3555 29.75 7 27.3945 7 24.5C7 22.043 9.09825 19.677 11.6777 19.2237L12.6945 19.0453L13.0305 18.0687C14.2607 14.4795 17.3162 12.25 21 12.25C25.8247 12.25 29.75 16.1753 29.75 21V22.75H31.5C33.4303 22.75 35 24.3197 35 26.25C35 28.1803 33.4303 29.75 31.5 29.75H26.25V33.25H31.5C35.3605 33.25 38.5 30.1105 38.5 26.25C38.4973 24.6813 37.9691 23.1588 36.9997 21.9255C36.0303 20.6921 34.6756 19.8192 33.152 19.446C32.3873 13.4225 27.23 8.75 21 8.75C16.177 8.75 11.9875 11.5692 10.0747 16.0125C6.31575 17.136 3.5 20.685 3.5 24.5C3.5 29.3247 7.42525 33.25 12.25 33.25Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.330e7adea931d6ecefa6e0d4ad301653.svg";
export { ForwardRef as ReactComponent };